module.exports = __webpack_public_path__ + "img/hospital.872d2995.png";